<script setup lang="ts">

import {computed} from 'vue'
import {FormControl, FormDescription, FormItem, FormLabel, FormMessage} from "@/shared/components/ui/form2/";
import {FormItemProps} from ".";
import {cn} from "@/shared/lib/utils.ts";
import FormError from "@/shared/components/ui/form2/FormError.vue";
import {Select, SelectContent, SelectTrigger, SelectValue} from "@/shared/components/ui/select";
import {SelectViewport} from "radix-vue";

interface FormSelectProps extends FormItemProps {
  placeholder?: string,
}

const props = withDefaults(defineProps<FormSelectProps>(), {
  required: false,
  type: "text"
});
const modelValue = defineModel<string>()
const hasError = computed(() => props.error != undefined)
</script>

<template>
  <FormItem :class="cn('form-select w-full', props.class)">
    <FormLabel v-if="label" :error="hasError" :class="disabled? 'text-slate-400' : ''">{{ label }}{{ required ? '*' : '' }}</FormLabel>
    <Select :disabled="disabled" v-model="modelValue" :class="props.elementClass">
      <FormControl>
        <SelectTrigger :class="cn('text-left disabled:bg-gray-50', props.elementClass, { 'border-red-600': hasError })">
          <SelectValue :class="modelValue ? '' : 'text-muted-foreground'" :placeholder="placeholder"/>
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        <SelectViewport>
          <slot/>
        </SelectViewport>
      </SelectContent>
    </Select>
    <FormError :error="error"/>
    <FormDescription v-if="description" v-html="description"/>
    <FormMessage/>
  </FormItem>
</template>

<style scoped>

</style>